import { create } from 'zustand';
import type { User } from './types';
import { auth, api, ApiClientError, tokenStore } from './api';

type AuthStatus = 'idle' | 'loading' | 'ready' | 'error';

interface AuthState {
  status: AuthStatus;
  user: User | null;
  error: string | null;
  init: () => Promise<void>;
  refreshMe: () => Promise<void>;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'idle',
  user: null,
  error: null,

  async init() {
    set({ status: 'loading', error: null });
    try {
      if (tokenStore.access) {
        const me = await api.users.me();
        set({ status: 'ready', user: me });
        return;
      }
      const tokens = await auth.loginWithInitData();
      set({ status: 'ready', user: tokens.user });
    } catch (e) {
      const msg =
        e instanceof ApiClientError ? e.message : (e as Error).message ?? 'Не удалось войти';
      set({ status: 'error', error: msg });
    }
  },

  async refreshMe() {
    try {
      const me = await api.users.me();
      set({ user: me });
    } catch {
      /* keep stale */
    }
  },

  logout() {
    auth.logout();
    set({ status: 'idle', user: null });
  },
}));

export function isMasterRole(role?: string | null): boolean {
  return role === 'master' || role === 'admin' || role === 'superadmin';
}

export function isAdminRole(role?: string | null): boolean {
  return role === 'admin' || role === 'superadmin';
}
